import * as types from "./actionTypes.js";
import * as tourApi from '../../api/tourApi.js';


export function fetchCreateTourPreReq(dayTypeId, resourceId, date, userId) {
    return function(dispatch) {
        return tourApi
            .getCreateTourPreReq(dayTypeId, resourceId, date, userId)
            .then(createTourPreReq => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_CREATE_TOUR_PRE_REQ_SUCCESS,
                    createTourPreReq
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function addTour(parameters) {
  return function(dispatch) {
      return tourApi
          .createTour(parameters)
          .then(tour => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.ADD_TOUR_SUCCESS,
                  tour
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function removeTour(tourId, userId) {
    return function(dispatch) {
        return tourApi
            .deleteTour(tourId, userId)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_TOUR_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }

  export function editTour(parameters) {
    return function(dispatch) {
        return tourApi
            .updateTour(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_TOUR_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }

  export function fetchActiveTours(resourceId, startTime, timeZoneId) {
    return function(dispatch) {
        return tourApi
            .getActiveTours(resourceId, startTime, timeZoneId)
            .then(activeTours => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_ACTIVE_TOURS_SUCCESS,
                    activeTours
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }

export function fetchTour(parameters) {
    return function(dispatch) {
        return tourApi
            .getTour(parameters)
            .then(tour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_SUCCESS,
                    tour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDefaultTourLength(relatedServiceId, startTime, resourceId, serviceId) {
    return function(dispatch) {
        return tourApi
            .getDefaultTourLength(relatedServiceId, startTime, resourceId, serviceId)
            .then(defaultTourLength => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DEFAULT_TOUR_LENGTH_SUCCESS,
                    defaultTourLength
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function addTourActivityFlag(parameters) {
    return function(dispatch) {
        return tourApi
            .createTourActivityFlag(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.ADD_TOUR_ACTIVITY_FLAG_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function addTourIndicator(parameters) {
    return function(dispatch) {
        return tourApi
            .createTourIndicator(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.ADD_TOUR_INDICATOR_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function addTourPayTransaction(parameters) {
    return function(dispatch) {
        return tourApi
            .createTourPayTransaction(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.ADD_TOUR_PAY_TRANSACTION_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeTourActivityFlag(parameters) {
    return function(dispatch) {
        return tourApi
            .deleteTourActivityFlag(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_TOUR_ACTIVITY_FLAG_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeTourIndicator(tourIndicatorId) {
    return function(dispatch) {
        return tourApi
            .deleteTourIndicator(tourIndicatorId)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_TOUR_INDICATOR_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeTourPayTransaction(parameters) {
    return function(dispatch) {
        return tourApi
            .deleteTourPayTransaction(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_TOUR_PAY_TRANSACTION_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchActivityFlagByTour(tourId) {
    return function(dispatch) {
        return tourApi
            .getActivityFlagByTour(tourId)
            .then(activityFlagByTour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_ACTIVITY_FLAG_BY_TOUR_SUCCESS,
                    activityFlagByTour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourActivityFlags(tourId) {
    return function(dispatch) {
        return tourApi
            .getTourActivityFlags(tourId)
            .then(tourActivityFlags => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_ACTIVITY_FLAGS_SUCCESS,
                    tourActivityFlags
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchCodesByIndicator(indicatorId) {
    return function(dispatch) {
        return tourApi
            .getCodesByIndicator(indicatorId)
            .then(codesByIndicator => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_CODES_BY_INDICATOR_SUCCESS,
                    codesByIndicator
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchIndicatorsById(indicatorId) {
    return function(dispatch) {
        return tourApi
            .getIndicatorsById(indicatorId)
            .then(indicatorsById => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_INDICATORS_BY_ID_SUCCESS,
                    indicatorsById
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchIndicatorsByTour(tourId) {
    return function(dispatch) {
        return tourApi
            .getIndicatorsByTour(tourId)
            .then(indicatorsByTour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_INDICATORS_BY_TOUR_SUCCESS,
                    indicatorsByTour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchJobElementsByTour(tourId) {
    return function(dispatch) {
        return tourApi
            .getJobElementsByTour(tourId)
            .then(jobElementsByTour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_JOB_ELEMENTS_BY_TOUR_SUCCESS,
                    jobElementsByTour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourMeals(tourId) {
    return function(dispatch) {
        return tourApi
            .getTourMeals(tourId)
            .then(tourMeals => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_MEALS_SUCCESS,
                    tourMeals
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchPayTransactionsByTour(parameters) {
    return function(dispatch) {
        return tourApi
            .getPayTransactionsByTour(parameters)
            .then(payTransactionsByTour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_PAY_TRANSACTIONS_BY_TOUR_SUCCESS,
                    payTransactionsByTour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourActivityFlag(tourActivityFlagId) {
    return function(dispatch) {
        return tourApi
            .getTourActivityFlag(tourActivityFlagId)
            .then(tourActivityFlag => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_ACTIVITY_FLAG_SUCCESS,
                    tourActivityFlag
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourIndicator(tourIndicatorId) {
    return function(dispatch) {
        return tourApi
            .getTourIndicator(tourIndicatorId)
            .then(tourIndicator => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_INDICATOR_SUCCESS,
                    tourIndicator
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourIndicators(tourId) {
    return function(dispatch) {
        return tourApi
            .getTourIndicators(tourId)
            .then(tourIndicators => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_INDICATORS_SUCCESS,
                    tourIndicators
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourPayTransactions(tourId) {
    return function(dispatch) {
        return tourApi
            .getTourPayTransactions(tourId)
            .then(tourPayTransactions => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_PAY_TRANSACTIONS_SUCCESS,
                    tourPayTransactions
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchTourPayTransaction(tourPayTransactionId) {
    return function(dispatch) {
        return tourApi
            .getTourPayTransaction(tourPayTransactionId)
            .then(tourPayTransaction => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_TOUR_PAY_TRANSACTION_SUCCESS,
                    tourPayTransaction
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchIfToursAreInDateRange(parameters) {
    return function(dispatch) {
        return tourApi
            .getIfToursAreInDateRange(parameters)
            .then(tours => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_IF_TOURS_ARE_IN_DATE_RANGE,
                    tours
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function editTourActivityFlag(parameters) {
    return function(dispatch) {
        return tourApi
            .updateTourActivityFlag(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_TOUR_ACTIVITY_FLAG_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function editTourIndicator(parameters) {
    return function(dispatch) {
        return tourApi
            .updateTourIndicator(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_TOUR_INDICATOR_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function editTourPayTransaction(parameters) {
    return function(dispatch) {
        return tourApi
            .updateTourPayTransaction(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_TOUR_PAY_TRANSACTION_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

